import React from 'react';
import { Link } from 'react-router-dom';

export let ManageBankColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'bank_name',
    text: 'Bank Name',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
    )
  },
  {
    dataField: 'ac_no',
    text: 'Account Number',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => <span className="font-family-monospace font-weight-semibold">{cell || 'N/A'}</span>
  },
  { dataField: 'ifsc_code', text: 'IFSC Code', style: { verticalAlign: 'middle' } },
  { dataField: 'branch', text: 'Branch', style: { verticalAlign: 'middle' } },
  { dataField: 'ac_type', text: 'Account Type', style: { verticalAlign: 'middle' } },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    style: { verticalAlign: 'middle', textAlign: 'center', width: '100px' },
    headerStyle: { textAlign: 'center', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageTreatmentsColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Treatment / Procedure',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <div className="d-flex align-items-center gap-2 py-1">
        <div className="bg-primary-subtle text-primary p-1.5 rounded-circle d-flex align-items-center justify-content-center font-size-13 flex-shrink-0" style={{ width: '30px', height: '30px' }}>
          <i className="fas fa-tooth" />
        </div>
        <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
      </div>
    )
  },
  {
    dataField: 'cost',
    text: 'Standard Fee',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <span className="badge bg-success-subtle text-success border border-success-subtle px-2.5 py-1 rounded-pill font-weight-bold font-size-12">
        ₹{parseFloat(cell || 0).toLocaleString('en-IN')}
      </span>
    )
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    style: { verticalAlign: 'middle', textAlign: 'center', width: '100px' },
    headerStyle: { textAlign: 'center', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageMedicineColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'name',
    text: 'Medicine Name',
    style: { verticalAlign: 'middle' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center gap-2 py-1">
        <div className="bg-info-subtle text-info p-1.5 rounded-circle d-flex align-items-center justify-content-center font-size-13 flex-shrink-0" style={{ width: '30px', height: '30px' }}>
          <i className="fas fa-capsules" />
        </div>
        <div>
          <strong className="text-dark font-size-13 d-block">{cell || 'N/A'}</strong>
          {row.molucule && <div className="text-muted font-size-11">{row.molucule}</div>}
        </div>
      </div>
    )
  },
  {
    dataField: 'dose',
    text: 'Dosage',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => cell ? (
      <span className="badge bg-light text-dark border font-size-11 px-2 py-1">
        {cell}
      </span>
    ) : <span className="text-muted font-size-12">—</span>
  },
  {
    dataField: 'duration',
    text: 'Duration',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => cell ? (
      <span className="badge bg-light text-primary border font-size-11 px-2 py-1">
        ⏱️ {cell}
      </span>
    ) : <span className="text-muted font-size-12">—</span>
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    style: { verticalAlign: 'middle', textAlign: 'center', width: '100px' },
    headerStyle: { textAlign: 'center', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageAllergiesColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Symptom / Allergy',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <div className="d-flex align-items-center gap-2 py-1">
        <div className="bg-danger-subtle text-danger p-1.5 rounded-circle d-flex align-items-center justify-content-center font-size-13 flex-shrink-0" style={{ width: '30px', height: '30px' }}>
          <i className="fas fa-notes-medical" />
        </div>
        <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
      </div>
    )
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageCommunicationGroupColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Communication Group',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageTagColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Tag Name',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <span className="badge bg-light text-dark border px-2.5 py-1 font-size-12">
        🏷️ {cell || 'N/A'}
      </span>
    )
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageChairsColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Dental Chair',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => <strong className="text-dark font-size-13">🪑 {cell || 'N/A'}</strong>
  },
  { dataField: 'cabin_no', text: 'Cabin No', style: { verticalAlign: 'middle' } },
  { dataField: 'start_time', text: 'Start Time', style: { verticalAlign: 'middle' } },
  { dataField: 'end_time', text: 'End Time', style: { verticalAlign: 'middle' } },
  { dataField: 'intervel', text: 'Interval', style: { verticalAlign: 'middle' } },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageReferencesColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Referral Source',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageRXTemplatetColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Rx Protocol & Template',
    style: { verticalAlign: 'middle', minWidth: '240px' },
    formatter: (cell, row) => {
      let medsCount = 0;
      let medsList = [];
      try {
        const raw = row.medicins || row.medicine || row.medicines;
        if (raw) {
          const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
          if (Array.isArray(parsed)) {
            medsList = parsed;
            medsCount = parsed.length;
          }
        }
      } catch (e) {}

      return (
        <div className="d-flex align-items-center gap-2 py-1">
          <div className="bg-primary-subtle text-primary p-2 rounded-circle d-flex align-items-center justify-content-center font-size-14 flex-shrink-0" style={{ width: '32px', height: '32px' }}>
            <i className="fas fa-file-prescription" />
          </div>
          <div>
            <strong className="text-dark font-size-13 d-block">{typeof cell === 'object' ? (cell?.label || cell?.name || cell?.title || 'Untitled Rx Protocol') : (cell || 'Untitled Rx Protocol')}</strong>
            {medsCount > 0 && (
              <button
                type="button"
                className="btn btn-xs py-0.5 px-2 rounded-pill font-size-10 mt-1 d-inline-flex align-items-center gap-1.5 font-weight-semibold shadow-2xs border-0"
                style={{ backgroundColor: '#e0f2fe', color: '#0369a1' }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  callback?.viewMedicines && callback.viewMedicines(row, medsList);
                }}
                title="Click to view full medication details"
              >
                <i className="fas fa-pills font-size-9" /> {medsCount} {medsCount === 1 ? 'Medication' : 'Medications'}
                <i className="fas fa-eye font-size-8 ms-0.5 opacity-75" />
              </button>
            )}
          </div>
        </div>
      );
    }
  },
  {
    dataField: 'doctor_code',
    text: 'Doctor',
    style: { verticalAlign: 'middle', width: '160px' },
    formatter: (cell, row) => {
      const docName = typeof row.doctor?.name === 'string' ? row.doctor.name : (typeof cell === 'string' && cell && cell !== 'ALL' ? cell : 'All Clinic Doctors');
      const isAll = !cell || cell === 'ALL' || !row.doctor_code;
      return (
        <span className={`badge ${isAll ? 'bg-light text-secondary border' : 'bg-soft-primary text-primary border border-primary-subtle'} font-size-11 px-2.5 py-1 rounded-pill font-weight-medium d-inline-flex align-items-center gap-1`}>
          <i className={`fas ${isAll ? 'fa-hospital' : 'fa-user-md'} font-size-10`} /> {docName}
        </span>
      );
    }
  },
  {
    dataField: 'note',
    text: 'Clinical Instructions',
    style: { verticalAlign: 'middle', maxWidth: '300px' },
    formatter: (cell) => cell ? (
      <div className="text-muted font-size-12 text-truncate" style={{ maxWidth: '300px' }} title={cell}>
        {cell}
      </div>
    ) : (
      <span className="text-muted font-size-11 opacity-50">—</span>
    )
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`} style={{ width: '28px', height: '28px' }} onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)} title={row.status === 0 ? 'Delete' : 'Restore'} >
          <i className={`fas ${row.status === 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];

export let ManageDentalChartColumns = (callback = {}, pagination) => [
  {
    dataField: 'id',
    text: '#',
    style: { width: '50px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => {
      const page = pagination?.page || 1;
      const limit = pagination?.limit || 10;
      return (
        <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
          {(page - 1) * limit + (rowIndex + 1)}
        </span>
      );
    }
  },
  {
    dataField: 'title',
    text: 'Examination Type',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => <strong className="text-dark font-size-13">{cell || 'N/A'}</strong>
  },
  {
    dataField: 'group',
    text: 'Examination Options & Findings',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => {
      let items = [];
      try {
        items = cell ? (typeof cell === 'string' ? JSON.parse(cell) : cell) : [];
      } catch (e) {
        items = [];
      }
      return (
        <div className="d-flex flex-wrap gap-1 py-1">
          {items.map((item, i) => (
            <span key={i} className="badge bg-light text-secondary border font-size-11 px-2 py-0.5">
              {item.value || item.label || item}
            </span>
          ))}
        </div>
      );
    }
  },
  {
    dataField: 'actions',
    text: 'Action',
    isDummyField: true,
    headerStyle: { textAlign: 'center', width: '100px' },
    style: { textAlign: 'center', verticalAlign: 'middle', width: '100px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <Link to="#" className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1" style={{ width: '28px', height: '28px' }} onClick={() => callback?.edit(row)} title="Edit" >
          <i className="fas fa-pencil-alt font-size-11" />
        </Link>
        <Link to="#" className={`btn btn-sm btn-soft-${row.status === 0 ? 'danger' : 'success'} rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs me-1`}
          onClick={() => callback?.delete(row.id, row.status === 1 ? 0 : 1, row.code)}
          title={row.status === 0 ? 'Delete' : 'Restore'}>
          <i className={`fas ${row.status == 0 ? 'fa-trash-alt' : 'fa-check'} font-size-11`} />
        </Link>
      </div>
    )
  }
];
